<template>
    <v-container fluid>
        <div v-if="orderComplete">
            <v-card elevation="10">
                <v-card-title class="white--text secondary">Thank You!</v-card-title>
                <v-card-text class="text-left">
                    Your order is now complete.
                </v-card-text>
            </v-card>
        </div>
        <div v-if="cart">
            <cart-header :cart="cart"></cart-header>
            <v-card elevation="10">
                <v-card-title class="white--text secondary">Checkout</v-card-title>
                <v-card-text class="text-left">
                    <div><b>Cart Total: </b>${{cart.orderTotal}}</div>

                    <card class='stripe-card' v-show="!executing"
                          :class='{ complete }'
                          :stripe='cart.stripePublicKey'
                          :options='stripeOptions'
                          @change='complete = $event.complete'
                    />
                    <v-btn @click="pay" v-show="!executing" :disabled="!complete" color="green" class="white--text"><v-icon color="white" left>mdi-credit-card-outline</v-icon>Pay Now</v-btn>


                </v-card-text>
            </v-card>

        </div>


        <v-dialog max-width="290" persistent v-model="errorDialog">
            <v-card>
                <v-card-title class="error white--text">Error</v-card-title>
                <v-card-text>{{errorText}}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="errorDialog = false" color="green" class="white--text" text>OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import api from "../services/aggrega8-api";
    import moment from 'moment';
    import {Card, createToken} from 'vue-stripe-elements-plus'
    import CartHeader from "./CartHeader";
    import _ from 'lodash';

    export default {
        name: 'Checkout',
        components: {CartHeader, Card },
        computed: {
            apiKey: function () {
                return this.$store.state.apiKey
            },
            userDetails: function () {
                return this.$store.state.userDetails
            },
            loggedIn: function () {
                return this.$store.state.loggedIn
            },
            executing: function () {
                return this.$store.state.executing
            },
            orderNote: function() {
                return this.$store.state.orderNote;
            }
        },
        data: () => ({
            showNotFound: false,
            errorText: "",
            errorDialog: false,
            cart: null,
            items: null,
            stripeOptions: {
                requestPayerName: true,
                requestPayerEmail: true
            },
            orderComplete: false,
            complete: false
        }),
        mounted() {
            window.scrollTo(0, 0)
            this.$store.dispatch("setExecuting", true)
            api.get("/consumer/cart/" + this.$route.params.id).then(
            (results) => {
                this.cart = results.data.cart
                this.items = results.data.items
            },
            (error) => {
                this.errorText = error.response.data
                this.errorDialog = true
            }).then(() => {
                this.$store.dispatch("setExecuting", false)
            })
        },
        methods: {
            formatDateTime(date) {
                return moment(date).format("MM/DD/YYYY hh:mm a")
            },
            pay () {
                // createToken returns a Promise which resolves in a result object with
                // either a token or an error key.
                // See https://stripe.com/docs/api#tokens for the token object.
                // See https://stripe.com/docs/api#errors for the error object.
                // More general https://stripe.com/docs/stripe.js#stripe-create-token.
                this.$store.dispatch("setExecuting", true)
                createToken().then(data =>
                                this.submitPayment(data.token)
                )
            },
            submitPayment(token) {
                this.$store.dispatch("setExecuting", true);
                let additionalData = {};

                if(this.orderNote)
                    additionalData.note = this.orderNote;

                let data = _.assign(token, additionalData);
                api.post("/consumer/stripePayment/" + this.$route.params.id, data).then(
                (results) => {
                    this.orderComplete = true
                    this.items = null
                    this.cart = null
                    this.$store.dispatch("setCartSize", results.data.cartSize);
                    this.$store.commit('SET_ORDER_NOTE', null);
                },
                (error) => {
                    alert("error!"+error)
                }).then(() => {
                    this.$store.dispatch("setExecuting", false)
                })
            },
        }
    }
</script>
<style scoped>
    .dist-logo {
        max-height: 100px;
        float: left;
        padding-right: 25px;
    }
    .cart-header {
        min-height: 125px;
    }

</style>
